// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React from 'react';
import { Link, useSearchParams } from 'react-router';
import { Box, Stack, Typography, Alert } from '@mui/material';
import Logo from '@/layouts/full/shared/logo/Logo';
import AuthLogin from '@/components/authForms/AuthLogin';
import { useTranslation } from '@/hooks/useTranslation';
import authBg from '@/assets/images/backgrounds/auth.jpg';

const Login = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const passwordReset = searchParams.get('passwordReset') === 'true';
  const emailVerified = searchParams.get('emailVerified') === 'true';

  return (
    <Box sx={{ height: '100vh', display: 'flex', overflow: 'hidden' }}>
      {/* Left side - Image (70%) */}
      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          width: '60%',
          height: '100vh',
          position: 'relative',
          overflow: 'hidden',
          flexShrink: 0,
          borderRadius: '0!important',
        }}
      >
        <Box
          component="img"
          src={authBg}
          alt="Auth background"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            display: 'block',
            borderRadius: '0!important',
          }}
        />
      </Box>

      {/* Right side - Form (30%) */}
      <Box
        sx={{
          width: { xs: '100%', md: '40%' },
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          p: { xs: 2, sm: 4 },
          overflow: 'auto',
          flexShrink: 0,
        }}
      >
          <Box
            sx={{ p: 4, zIndex: 1, width: '100%' }}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <Logo />
            </Box>

            {passwordReset && (
              <Alert variant="filled" severity="success" sx={{ mb: 2, mt: 2 }}>
                {t('login.passwordResetSuccess')}
              </Alert>
            )}

            {emailVerified && (
              <Alert variant="filled" severity="success" sx={{ mb: 2, mt: 2 }}>
                {t('login.emailVerifiedSuccess')}
              </Alert>
            )}

            <AuthLogin
              subtitle={
                <Stack
                  direction="row"
                  spacing={1}
                  justifyContent="center"
                  mt={3}
                >
                  <Typography
                    color="textSecondary"
                    variant="h6"
                    fontWeight="500"
                  >
                    {t('login.newToTuningFiles')}
                  </Typography>
                  <Typography
                    component={Link}
                    to="/signup"
                    fontWeight="500"
                    sx={{
                      textDecoration: 'none',
                      color: 'primary.main',
                    }}
                  >
                    {t('login.createAccount')}
                  </Typography>
                </Stack>
              }
            />
          </Box>
      </Box>
    </Box>
  );
};

export default Login;
